<template>
<div class="chapter">
<div class="inner_page">
<div class="cover" id="cover"><img alt="God's Big Picture" class="cover" src="Images/9780830863891.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?60be613b